module.exports = __webpack_public_path__ + "static/media/mini_games_btn.532e9c84.png";